import { render, staticRenderFns } from "./CbsJoinConstructor.vue?vue&type=template&id=6f167320&scoped=true"
import script from "./CbsJoinConstructor.vue?vue&type=script&lang=js"
export * from "./CbsJoinConstructor.vue?vue&type=script&lang=js"
import style0 from "./CbsJoinConstructor.vue?vue&type=style&index=0&id=6f167320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f167320",
  null
  
)

export default component.exports